import { PricingType } from "../data-types/pricing-structure";

export type PricingTypeKey = keyof typeof PricingType;

export const PricingTypeKeyByValue: Record<string, PricingTypeKey> = Object.freeze(
  Object.keys(PricingType).reduce((map: any, key: string) => {
    map[PricingType[key as PricingTypeKey]] = key;
    return map;
  }, {} as any)
);
